import type { FilaInventario } from "../types/inventario.types";

const ESTATUS_ACTIVO = 1;

const esObjeto = (valor: unknown): valor is Record<string, unknown> =>
    typeof valor === "object" && valor !== null;

const aTexto = (valor: unknown): string =>
    valor === undefined || valor === null ? "" : String(valor);
const aNumero = (valor: unknown): number => Number(valor) || 0;

const extraerArreglo = (respuesta: unknown): unknown[] => {
    if (Array.isArray(respuesta)) return respuesta;
    if (esObjeto(respuesta) && Array.isArray(respuesta.data)) return respuesta.data;
    return [];
};

interface OpcionesNormalizacionInventario {
    textoActivo: string;
    textoInactivo: string;
}

// Coincide 1:1 con el SELECT de InventarioController@getInventario:
// los joins ya devuelven los nombres como texto plano (unidad_medida, categoria,
// ubicacion, almacen, tipo_producto), no como relaciones anidadas.
export const normalizarFilasInventario = (
    respuesta: unknown,
    opciones: OpcionesNormalizacionInventario
): FilaInventario[] =>
    extraerArreglo(respuesta)
        .filter(esObjeto)
        .map((registro, posicion) => {
            const activo = aNumero(registro.estatus) === ESTATUS_ACTIVO;

            return {
                id: aTexto(registro.id) === "" ? String(posicion) : aTexto(registro.id),
                clave: aTexto(registro.clave),
                nombre: aTexto(registro.nombre),
                tipoProducto: aTexto(registro.tipo_producto),
                categoria: aTexto(registro.categoria),
                unidadMedida: aTexto(registro.unidad_medida),
                ubicacion: aTexto(registro.ubicacion),
                almacen: aTexto(registro.almacen),
                precio: aNumero(registro.precio),
                cantidad: aNumero(registro.cantidad),
                maximos: aNumero(registro.maximos),
                minimos: aNumero(registro.minimos),
                puntoReorden: aNumero(registro.punto_reorden),
                fechaCreacion: aTexto(registro.fecha_creacion),
                estatus: activo ? opciones.textoActivo : opciones.textoInactivo,
                activo,
                registro,
            };
        });

// Usado al abrir el modal de edición: mapea el registro plano de vuelta a los
// campos que espera InventarioController@editarProductoInventario.
export const valoresDeEdicionInventario = (
    registro: Record<string, unknown>
): Record<string, string> => ({
    clave: aTexto(registro.clave),
    nombre: aTexto(registro.nombre),
    precio: aTexto(registro.precio),
    id_unidad_medida: aTexto(registro.id_unidad_medida),
    id_categoria: aTexto(registro.id_categoria),
    id_ubicacion: aTexto(registro.id_ubicacion),
    id_tipo_producto: aTexto(registro.id_tipo_producto),
    maximos: aTexto(registro.maximos),
    minimos: aTexto(registro.minimos),
    punto_reorden: aTexto(registro.punto_reorden),
});